
/**
 * Module dependencies.
 */

import { QueryObserverBaseResult, useQuery } from 'react-query';
import { fetchFaqs } from './fetch-faqs';
import { useMemo } from 'react';
import { useRouter } from 'next/router';

/**
 * `Props` type.
 */

type Props<P> = QueryObserverBaseResult<P, unknown>;

/**
 * `Options` type.
 */

type Options<P> = {
  initialData?: P | null
};

/**
 * Action type.
 */

export const actionType = ({ locale }): string => {
  return `${locale}-faqs`;
};

/**
 * `useFaqs` hook.
 */

function useFaqs<P>(options?: Options<P>): Props<P> {
  const { locale } = useRouter();
  const variables = useMemo(() => ({ locale }), [locale]);
  const result = useQuery([actionType(variables), variables], () => {
    return fetchFaqs(variables);
  }, {
    initialData: options?.initialData
  });

  return result;
}

/**
 * Export `useFaqs` hook.
 */

export default useFaqs;
